import type { RichTextImageUploadCredentials } from './rich-text-image-types';

const S3_FIELD_NAME_MAP: Record<string, string> = {
  contentType: 'Content-Type',
  key: 'key',
  awsAccessKeyId: 'AWSAccessKeyId',
  xAmzSecurityToken: 'x-amz-security-token',
  policy: 'policy',
  signature: 'signature',
  xAmzAlgorithm: 'x-amz-algorithm',
  xAmzCredential: 'x-amz-credential',
  xAmzDate: 'x-amz-date',
  xAmzSignature: 'x-amz-signature',
};

export const uploadToS3 = async (
  file: File,
  credentials: RichTextImageUploadCredentials
): Promise<void> => {
  const formData = new FormData();

  for (const [camelKey, value] of Object.entries(credentials.uploadFields)) {
    const s3FieldName = S3_FIELD_NAME_MAP[camelKey] || camelKey;
    formData.append(s3FieldName, value);
  }

  formData.append('file', file);

  const response = await fetch(credentials.uploadUrl, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('Upload credentials expired. Please try again.');
    }
    throw new Error('Upload failed. Please try again.');
  }
};
